// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Image, IStackStyles, ITextStyles, Stack, Text } from '@fluentui/react';
import acsLogo from '../assets/acsLogo.svg';

export const HomeButton = (props: { onClick: () => void }): JSX.Element => {
  return (
    <Stack
      horizontal
      tabIndex={0}
      verticalFill
      onClick={props.onClick}
      verticalAlign="center"
      tokens={{ childrenGap: '0.75rem' }}
      styles={homeButtonStyles}
    >
      <Stack.Item>
        <Image src={acsLogo.toString()} alt="Azure Communication Services Logo" />
      </Stack.Item>
      <Stack.Item>
        <Text styles={homeTextStyles}>ACS Selfhost</Text>
      </Stack.Item>
    </Stack>
  );
};

const homeButtonStyles: IStackStyles = {
  root: {
    cursor: 'pointer'
  }
};

const homeTextStyles: ITextStyles = {
  root: {
    fontWeight: '600',
    fontSize: '0.875rem'
  }
};
